<template>
  <f7-app :params="f7params" >

    <!-- Left panel with cover effect-->
    <f7-panel left cover>
      <f7-view links-view=".view-main" :pushStateOnLoad="false">
          <panel-left></panel-left>
      </f7-view>
    </f7-panel>


    <f7-view
            main
            :animate="false"
            class="safe-areas"
            url="/"
            >
    </f7-view>




  </f7-app>
</template>
<script>

  import routes from '../js/routes.js';
  import PanelLeft from '../pages/panel-left.vue';

  export default {
    components: {
      'panel-left': PanelLeft
    },
    data() {
      return {
        // Framework7 Parameters
        f7params: {
          name: 'SHMU', // App name
          theme: 'auto', // Automatic theme detection
          panel: {
            swipe: 'left',
          },
          view: {
            pushState: true,
            pushStateSeparator: '#!',
            pushStateOnLoad: true
          },
          // App root data
          data: function () {
            return {
              // inicializacne data, napr zoznamy stanic z localcache a pod
            };
          },
          pushState: true,
          history: true,
          cache:false,
          // App routes
          routes: routes,
        },

      }
    },
    methods: {

    },
    mounted() {
      this.$f7ready((f7) => {

        // Call F7 APIs here
      });
    }
  }
</script>

